var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-skeleton"},[_vm._l((6),function(key){return [_c('div',{key:key,staticClass:"row"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }